import { connectSortBy } from "instantsearch.js/es/connectors";
import { provide, ref } from "vue";
export const useAisSortBy = (widgetParams, id = "") => {
  const stateRef = ref();
  const renderSortBy = (renderState, isFirstRender) => {
    stateRef.value = renderState;
    if (isFirstRender) {
      provide(`sortBy-${id}`, stateRef);
    }
    return () => {
    };
  };
  const customSortBy = connectSortBy(renderSortBy);
  return {
    ...customSortBy(widgetParams),
    $$widgetParams: widgetParams,
    $$widgetId: id
  };
};
